<template>
  <v-layout row>
    <v-flex 
      sm12 
      md8 
      offset-md2
      xl6
      offset-xl3>
      <v-alert 
        :type="alert.type" 
        v-model="alert.show">
        {{ alert.text }}
      </v-alert>
      <v-card>
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>Placement List</v-toolbar-title>
        </v-toolbar>
        <v-list 
          two-line 
          subheader>
          <v-list-tile 
            v-for="item in placements" 
            :key="item['.key']" 
            :to="{path: '/student/' + item.unit, query: {key: item['.key']}}" 
            :class="item.nextStepType === 'Student' ? 'grey lighten-4' : ''"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.unit + ' - ' + item.unitName }}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{ item.startDate | moment("L") }} - {{ item.endDate | moment("L") }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ item.organisationName }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-content
              class="hidden-xs-only" 
              v-if="standardArray(item).length > 0">
              <v-tooltip bottom>
                <v-list-tile-sub-title slot="activator"> 
                  <span 
                    v-for="(standard, index) in standardArray(item)"
                    :key=" index">
                    <v-chip 
                      v-if="standard && standard.count > 0"                    
                      :color="standard.color" 
                      text-color="white">
                      {{ standard.count }}
                      <v-icon right>{{ standard.icon }}</v-icon>
                    </v-chip>     
                  </span>                          
                </v-list-tile-sub-title>
                <span>Standard results</span>
              </v-tooltip>
            </v-list-tile-content>
            <v-list-tile-action class="hidden-xs-only">
              <v-tooltip bottom>
                <v-chip 
                  slot="activator"
                  color="light-blue" 
                  text-color="white">
                  <v-avatar 
                    left 
                    class="blue darken-4">{{ item.step }}</v-avatar>
                  {{ item.nextStep }}
                </v-chip>
                <span>Current step</span>
              </v-tooltip>
              <span class="caption grey--text text--darken-1">Last update: {{ item.lastUpdate.seconds | moment("calendar") }}</span>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-card-text>
          <StudentPlacementForm 
            :edititem="placement"
            @alertText="alert = $event"/>            
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "PlacementForm",
  data: () => ({
    hidden: false,
    dialog: false,
    valid: true,
    alert: {
      text: null,
      type: null,
      show: false
    },
    placements: null,
    placement: {
      studentId: null,
      uid: null,
      displayName: null,
      email: null,
      course: null,
      courseName: null,
      unit: null,
      unitName: null,
      startDate: null,
      endDate: null,
      campus: null,
      organisation: null,
      nextStep: null,
      step: null
    }
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  firestore() {
    return {
      placements: this.$store.getters.db
        .collection("students")
        .doc(this.user.uid)
        .collection("placements")
        .orderBy("lastUpdate", "desc")
    };
  },
  methods: {
    standardArray(placement) {
      let success = { color: "success", icon: "check_circle", count: 0 };
      let warning = { color: "warning", icon: "info", count: 0 };
      let error = { color: "error", icon: "error", count: 0 };
      if (placement && placement.standardResults) {
        Object.keys(placement.standardResults).forEach(key => {
          success.count += placement.standardResults[key].success;
          warning.count += placement.standardResults[key].warning;
          error.count += placement.standardResults[key].error;
        });
        // Return empty array if no count values found
        if (success.count || warning.count || error.count) {
          return [success, warning, error];
        } else {
          return [];
        }
      } else {
        return [];
      }
    }
  }
};
</script>
